import * as React from 'react'
import { useContext } from 'react'

import { Hint as DesignSystemHint, dimensions } from '@factorialco/deprecated-design-system'
import { EnvironmentContext } from 'config/environment'

import i18n from 'modules/core/lib/i18n'

import { NODE_SIZE } from 'modules/org_chart/components/Node/constants'

interface Props {
  x: number
  y: number
}

const Hint: React.FC<React.PropsWithChildren<Props>> = ({ children, x, y }) => {
  const hintX = x + (NODE_SIZE[0] - 80) / 2

  const { hideOrgChartBannerAndHint } = useContext(EnvironmentContext)

  return (
    <foreignObject
      style={{ overflow: 'visible' }}
      width={dimensions.s80}
      height={dimensions.s80}
      x={hintX}
      y={y}
    >
      {hideOrgChartBannerAndHint ? (
        <>{children}</>
      ) : (
        <DesignSystemHint.Popover
          step={1}
          title={i18n.t('employees.orgchart.hint.title')}
          description={i18n.t('employees.orgchart.hint.description')}
          actionLabel={i18n.t('common.next')}
        >
          {children}
        </DesignSystemHint.Popover>
      )}
    </foreignObject>
  )
}

export default Hint
